import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-stepper',
  template: `
    <div class="stepper-container">
      <!-- Step Label -->
      <div class="tw-text-black tw-font-semibold">
        Paso {{ currentStep }} de {{ totalSteps }}
      </div>
      <!-- Circular Progress -->
      <div class="progress-container">
        <div
          class="progress-circle"
          [ngStyle]="{
            background: conicBackground,
            transform: 'rotate(0deg)'
          }"
        ></div>
        <div class="progress-cover"></div>
      </div>
    </div>
  `,
  styles: [
    `
      /* Stepper container (horizontal alignment) */
      .stepper-container {
        display: flex;
        align-items: center;
        gap: 8px; /* Space between the progress bar and the label */
      }

      /* Circular progress styles */
      .progress-container {
        position: relative;
        width: 25px; /* Diameter of the circular progress bar */
        height: 25px;
      }

      .progress-circle {
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background: conic-gradient(
          #fa5a55 0deg,
          #fa5a55 0deg
        ); /* Default blue color */
        transform-origin: center;
      }

      .progress-cover {
        position: absolute;
        inset: 4px; /* Adjust to create the hollow effect */
        background-color: white;
        border-radius: 50%;
      }
    `,
  ],
})
export class StepperComponent implements OnChanges {
  @Input() currentStep = 1; // Current step (e.g., 5)
  @Input() totalSteps = 1; // Total steps (e.g., 8)

  progressPercentage = 0; // Progress percentage (e.g., 62.5%)
  conicBackground = ''; // Background style for conic-gradient

  ngOnChanges(changes: SimpleChanges): void {
    this.calculateProgress();
  }

  private calculateProgress(): void {
    // Calculate percentage progress based on steps
    this.progressPercentage = Math.round(
      (this.currentStep / this.totalSteps) * 100
    );

    // Calculate the angle for the conic gradient
    // For example, for 50% progress, it should be 180 degrees, for 100% it should be 360 degrees
    const progressDegree = (this.progressPercentage / 100) * 360; // 360 degrees for a full circle

    // Adjust the conic gradient fill to start at 12:00 (top of the circle)
    this.conicBackground = `conic-gradient(#fa5a55 ${-0}deg, #fa5a55 ${progressDegree}deg, #e5e7eb ${
      progressDegree - 90
    }deg, #e5e7eb 360deg)`;
  }
}
